import React from 'react';
import { apiResource, companyName } from '../../utils';
import Layout from './theme/Layout';

const Us = () => {
  return (
    <Layout title="Nosotros">
      <div className="container py-5 py-lg-5">
        <div className="row align-items-center gy-4">
          {/* Imagen */}
          <div className="col-lg-5">
            <div className="position-relative">
              <div className="ratio ratio-4x3 rounded overflow-hidden shadow-sm">
                <img
                  src={apiResource({ url: 'images/dashboard/nosotros.png' })}
                  alt="Nosotros"
                  className="w-100 h-100"
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>

          {/* Texto */}
          <div className="col-lg-7">
            <span className="text-uppercase small text-primary fw-semibold mb-2 d-inline-block">
              Nosotros
            </span>
            <h1 className="h3 h2-lg mb-3">
              Creamos experiencias que se convierten en recuerdos.
            </h1>

            <p className="mb-3">
              Bienvenido. Nos alegra que estés aquí. Somos
              <span className="fw-semibold text-primary"> {companyName()}</span>, una
              plataforma dedicada a transformar la manera en que las personas viven,
              comparten y recuerdan los eventos.
            </p>

            <p className="mb-3">
              Desde conciertos y espectáculos hasta experiencias culturales y
              encuentros especiales, creemos firmemente que cada momento tiene el
              potencial de convertirse en algo extraordinario. Nuestro propósito es
              acercarte a esas experiencias y hacer que el proceso sea tan inspirador
              como el evento mismo.
            </p>

            <p className="mb-3">
              Trabajamos junto a organizadores, artistas y productoras para crear
              espacios donde la creatividad, la emoción y la autenticidad puedan
              fluir. Para nosotros, un evento no es solo un día en el calendario:
              es una historia que se escribe con dedicación, cuidado y un profundo
              respeto por el público.
            </p>

            <p className="mb-3">
              Cada proyecto que emprendemos está guiado por un compromiso claro:
              brindar calidad, confianza y una experiencia impecable desde el primer
              clic hasta el último aplauso. Queremos que disfrutes el camino tanto
              como el destino, porque el verdadero valor de un evento está en cómo
              nos conecta y nos transforma.
            </p>

            <p className="mb-0">
              Gracias por acompañarnos. Estamos aquí para seguir creando experiencias
              que merezcan ser recordadas.
            </p>

            <div className="mt-4">
              <span className="fw-semibold">{companyName()}</span>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Us;
